import { MANUAL_SPOT_LIBRARY_SUFFIX } from '../../config/config';

const VALID_HOSTS = new Set(['route.mezzoforte.design', 'route-beta.mezzoforte.design']);

const VALID_PATH = '/manual-code';

export const removeManualCodeLibrarySuffix = (code) => {
  if (!code) {
    return;
  }
  // Create a regular expression pattern based on the updated schema
  const pattern = new RegExp(`${MANUAL_SPOT_LIBRARY_SUFFIX}[A-Za-z0-9]{16}`);
  // Use replace method to remove the matching part of the string
  const result = code.replace(pattern, '');
  // return
  return result;
};

/**
 * validateManualCodeUrl(url: string): boolean
 * Checks:
 *  - https scheme
 *  - host is route.mezzoforte.design or route-beta.mezzoforte.design
 *  - path is exactly /manual-code
 *  - has a non-empty ?agami-manual-code=... param
 */
export const validateManualCodeUrl = (url) => {
  try {
    const u = new URL(url);
    if (u.protocol !== 'https:') return false;
    if (!VALID_HOSTS.has(u.hostname)) return false;
    if (u.pathname !== VALID_PATH) return false;

    const code = u.searchParams.get('agami-manual-code');
    if (code == null) return false; // missing
    if (code.trim() === '') return false; // empty/whitespace only

    // If you want to disallow spaces entirely, uncomment:
    // if (/\s/.test(code)) return false;

    return true;
  } catch {
    return false; // invalid URL string
  }
};

/**
 * getManualCode(url: string): string|null
 * Extracts the value of ?agami-manual-code=... (decoded), or null if missing/invalid URL.
 */
export const extractManualCode = (url) => {
  try {
    const u = new URL(url);
    const val = u.searchParams.get('agami-manual-code');
    return val ?? null;
  } catch {
    return null;
  }
};
